import React, { useState, useEffect } from "react";
import styles from "./PopUpEinwilligung.module.css";
import Button from "@mui/material/Button";

// Nur diese Keys werden durch die Einwilligung geschützt (siehe Kontakt.jsx: dort
// werden Name/E-Mail/Termin nur bei erteilter Einwilligung im LocalStorage zwischen-
// gespeichert). Bei Ablehnung werden ausschließlich diese Keys gelöscht - NICHT der
// komplette LocalStorage, da dort z.B. auch der Foodosia-Speiseplan liegt
// (foodosia-daily-plan:*, siehe dailyMenuApi.js), der nichts mit dieser Einwilligung
// zu tun hat und durch eine Ablehnung nicht verloren gehen darf.
const CONSENT_GATED_STORAGE_KEYS = ["form_data", "timeexpired", "last_submit"];

function clearConsentGatedStorage() {
  CONSENT_GATED_STORAGE_KEYS.forEach((key) => localStorage.removeItem(key));
}

function PopupEinwilligung({ children }) {
  const [consent, setConsent] = useState(() => {
    const saved = localStorage.getItem("user_consent");
    return saved === "true" ? true : saved === "false" ? false : null;
  });

  useEffect(() => {
    if (consent === false) {
      clearConsentGatedStorage();
    }
  }, [consent]);

  const handleConsent = (value) => {
    setConsent(value);
    localStorage.setItem("user_consent", value);
    if (!value) {
      clearConsentGatedStorage();
    }
  };

  useEffect(() => {
    document.body.style.overflow = consent === null ? "hidden" : "";
    return () => (document.body.style.overflow = "");
  }, [consent]);

  return (
    <>
      {consent === null && (
        <div className={styles.cookieOverlay}>
          <div className={styles.cookiePopup}>
            <h2 className={styles.cookieTitle}>
              Einwilligung zur Datenspeicherung
            </h2>
            <p className={styles.cookieText}>
              Wir speichern deine Angaben im LocalStorage deines Browsers, um
              dir das Ausfüllen zu erleichtern. Bei weiteren Fragen lies bitte
              unsere <a href="/datenschutzerklaerung">Datenschutzerklärung</a>{" "}
              und <a href="/agb">AGB</a>.
            </p>
            <Button
              id={styles.cookieBtnPrimary}
              onClick={() => handleConsent(true)}
              fullWidth
              disableElevation
              variant="contained"
            >
              Akzeptieren
            </Button>
            <button
              className={styles.cookieLink}
              onClick={() => handleConsent(false)}
            >
              Nicht akzeptieren
            </button>
          </div>
        </div>
      )}

      <div
        style={
          consent === null
            ? { filter: "blur(4px)", pointerEvents: "none", userSelect: "none" }
            : {}
        }
      >
        {children}
      </div>
    </>
  );
}

export default PopupEinwilligung;
